import React from 'react'
import { DismissibleTooltip } from '../../../../common/DismissibleTooltip'
import { useIsMobile } from '../hooks'

interface MobileTooltipProps {
  title: React.ReactNode
  children: React.ReactElement
}

/** Tooltip that only appears on mobile, where button text is hidden */
export const MobileTooltip: React.FC<MobileTooltipProps> = ({ title, children }) => {
  const isMobile = useIsMobile()

  if (!isMobile) {
    return children
  }

  return (
    <DismissibleTooltip title={title} placement="left">
      {children}
    </DismissibleTooltip>
  )
}
